import UserPreview from './UserPreview';

export default UserPreview;


// WEBPACK FOOTER //
// ./resources/assets/js/components/UserPreview/index.js